module.exports = __webpack_public_path__ + "assets/img/budapark2-640.a28bd4aa.webp";